import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]

import { ossToken } from '@/api/user';
import OSS from 'ali-oss';
import message from 'ant-design-vue/lib/message';
import {ref, watch, onMounted, nextTick} from 'vue'
import { getUUID } from '@/components/ts/components'
import {getById} from "@/api/designer";

export default /*#__PURE__*/_defineComponent({
  __name: 'UploadImagePreview',
  props: {
    path: {
        type: String,
        default: ""
    },
    fileName: {
        type: String,
        default: ""
    },
    fileUrl: {
        type: String,
        default: ""
    },
    imageUrl: {
        type: String,
        default: ''
    },
},
  emits: ['onSuccess', 'onRemove'],
  setup(__props, { emit: emits }) {

const props = __props;

const previewVisible = ref(false);
const previewImage = ref('');
const previewTitle = ref('');


const fileList = ref<any[]>([
]);
watch( () => props.path, async (newVal) => {
    console.log('图片路径发生改变了', newVal);
    await nextTick(()=>{
        fileList.value = props.path ? [
            {
                url: props.path.split('?')[0],
            },] : []
    })
},
    {
        immediate: true,
        deep: true,
    })

onMounted(() => {
    console.log('图片路径', props.path);
})

const url = ref('');
const handleCancel = () => {
    previewVisible.value = false;
    previewTitle.value = '';
};
const handlePreview = async (file: any) => {
    if (!file.url && !file.preview) {
        file.preview = (await getBase64(file.originFileObj)) as string;
    }
    previewImage.value = file.url || file.preview;
    previewVisible.value = true;
    previewTitle.value = props.fileName || file.url.substring(file.url.lastIndexOf('/') + 1);
};
function getBase64(file: File) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
const handleRemove = () => {
    fileList.value = []
    emits('onRemove', url.value ?? props.path)
}

const beforeUpload = async (file: any) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG file!');
        emits('onSuccess', '')
        return false;
    }
    ossToken().then(async (res: any) => {
        let sts = res
        console.log(sts);
        const client = new OSS({
            region: sts.region,
            accessKeyId: sts.accessKey,
            accessKeySecret: sts.accessSecret,
            stsToken: sts.token,
            bucket: sts.bucket,
            secure: true,
            endpoint: "https://"+sts.endpoint,
        })
        const fileName = props.fileName ? `${props.fileName}` : getUUID();
        const name = `${props.fileUrl}/${fileName}${file.name.substring(file.name.lastIndexOf('.'))}`
        console.log(name)
        const ali: any = await client.multipartUpload(name, file, { headers: { "Access-Control-Allow-Origin": "*" }, });
        if (ali.res.status === 200) {
            url.value = ali.res.requestUrls[0]
            emits('onSuccess', ali.res.requestUrls[0].split('?')[0])
            message.info(`上传成功`)
        } else {
            message.error(`上传失败`)
        }
    })
    return false;
}



return (_ctx: any,_cache: any) => {
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_upload, {
      "file-list": fileList.value,
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
      class: "avatar-uploader",
      "list-type": "picture-card",
      onPreview: handlePreview,
      "before-upload": beforeUpload,
      onRemove: handleRemove
    }, {
      default: _withCtx(() => [
        (fileList.value.length < 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_plus_outlined)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["file-list"]),
    _createVNode(_component_a_modal, {
      width: "70%",
      visible: previewVisible.value,
      title: previewTitle.value,
      footer: null,
      onCancel: handleCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          alt: "example",
          style: {"width":"100%"},
          src: previewImage.value
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})